import { CSSProperties } from "react";
import { FormGroup } from "reactstrap";
import { useField } from "formik";

import Style from "./Style.module.scss";
import React from "react";
import { InpuLable } from "../InputLable/InputLable";

interface RadioOption<T = string | number | boolean> {
  label: string;
  value: T;
}

interface RadioGroupProps<T = string | number | boolean> {
  name: string;
  label?: string;
  options: RadioOption<T>[];
  hasLabel?: boolean;
  significant?: boolean;
  customLabelStyle?: CSSProperties;
  onChange?: (selected: RadioOption<T>) => void;
}

export const RadioGroup = <T extends string | number | boolean>({
  name,
  label,
  options,
  hasLabel = true,
  significant = false,
  customLabelStyle = {},
  onChange,
}: RadioGroupProps<T>) => {
  const [field, meta, helpers] = useField<RadioOption<T> | null>(name);

  return (
    <FormGroup className={Style["form-group"]}>
      {hasLabel && <InpuLable lableText={label} significant={significant} />}

      <div className={`${Style["input-wrapper"]} d-flex gap-4`}>
        {options.map((option) => (
          <label key={option.value.toString()} className="ml-3">
            <input
              type="radio"
              checked={field.value?.value === option.value}
              onChange={() => {
                helpers.setValue(option);
                onChange?.(option);
              }}
              className={Style["custom-radio"]}
            />

            <span className={`mr-1  ${Style["option-label"]}`}>
              {option.label}
            </span>
          </label>
        ))}
      </div>
      {meta.touched && meta.error && (
        <p
          style={{
            color: "red",
            margin: 0,
            marginRight: "10px",
            padding: 0,
            paddingTop: 5,
            fontSize: 11,
            borderTop: "1px solid red",
          }}
        >
          {meta.error}
        </p>
      )}
    </FormGroup>
  );
};
